export default __webpack_public_path__ + "static/BannerMultiTextAction-d313b6df291d28c643fc7c68c309e926.jpg";